import {useDispatch} from "react-redux";
import {login} from "../../redux/actions/authActions";
import {useAuthSelector} from "../../redux/reducers/authReducer";
import {useThemeSelector} from "../../redux/reducers/themeReducer";

export const useController = () => {
    const dispatch = useDispatch();
    const { loginInProgress } = useAuthSelector();
    const { darkMode } = useThemeSelector();

    return {
        login: values => {
            dispatch(login(values))
        },
        darkMode,
        loginInProgress
    };
};